import { Button, Spinner } from "@heroui/react";
import { FaThumbsUp, FaRegThumbsUp } from 'react-icons/fa';
import { useReviewLikes } from '~/hooks/useReviewLikes';
import { useContext } from 'react';
import { AuthModalContext } from '~/components/contexts/AuthModalContext/AuthModalContext';
import { useEvent } from "~/hooks/useEvent";

interface LikeButtonProps {
  reviewId: string;
  initialLikeCount: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const LikeButton = ({ reviewId, initialLikeCount, className, size = 'sm' }: LikeButtonProps) => {
  const { count, isLiked, toggleLike, isLoading, isAuthenticated } = useReviewLikes({
    reviewId,
    initialLikeCount,
  });
  const authModal = useContext(AuthModalContext);
  const { sendEvent } = useEvent();
  const iconSize = size === 'lg' ? 'w-5 h-5' : size === 'md' ? 'w-4 h-4' : 'w-3 h-3';
  const minWidth = size === 'lg' ? 'min-w-[100px]' : size === 'md' ? 'min-w-[90px]' : 'min-w-[80px]';

  const handleClick = () => {
    sendEvent('like_button_click', {
      reviewId,
      isLiked: isLiked,
      isAuthenticated: isAuthenticated,
    });
    if (!isAuthenticated && authModal) {
      authModal.showAuthModal();
      return;
    }
    toggleLike();
  };

  return (
    <Button
      variant="light"
      color={isLiked ? "primary" : "default"}
      startContent={
        <span className={`flex justify-center ${size === 'lg' ? 'mr-2' : ''}`}>
          {isLoading ? (
            <Spinner size={size} className={iconSize} />
          ) : (
            isLiked ? <FaThumbsUp className={`text-primary ${iconSize}`} /> : <FaRegThumbsUp className={iconSize} />
          )}
        </span>
      }
      className={`${minWidth} ${className || ''}`}
      isDisabled={isLoading}
      onPress={handleClick}
      size={size}
    >
      <span className="flex items-center gap-2">
        <span>{count}</span>
      </span>
    </Button>
  );
}; 